module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAPCAYAAACBdR0qAAAABHNCSVQICAgIfAhkiAAAAElJREFUSEtjrHn4/z8DFUGLPCMjOcYxjjoELdjICkZygp6QnlGHoIcQ1RMroSjAJT/qEIyoITcoqa1vNNfQPNeM1jXoQUxuiAAAnHIiIXUfqYcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangang2.png
// module id = qT1R
// module chunks = 1